import React from "react";
import { ListItem, ListItemText, Typography } from "@material-ui/core";
import { CreativesViewModel } from "validation/components/CreativeMappings/creativeMappingsRules";
import { OuterList, InnerList, useListHeaderStyles } from "pages/CreativeMappings/components";

interface MappingsListProps {
    creatives: CreativesViewModel[];
}

export const MappingsList = ({ creatives }: MappingsListProps) => {
    // TODO: wrap with styled components when possible
    const classes = useListHeaderStyles();

    return (
        <OuterList flex={2} disablePadding={true}>
            {creatives.map(({ width, height, target }, index) => {
                return (
                    <ListItem className={classes.row} key={index}>
                        <InnerList key={index}>
                            <ListItem divider={true}>
                                <ListItemText disableTypography={true}>
                                    <Typography variant="subtitle1">{width}</Typography>
                                </ListItemText>
                            </ListItem>
                            <ListItem divider={true}>
                                <ListItemText disableTypography={true}>
                                    <Typography variant="subtitle1">{height}</Typography>
                                </ListItemText>
                            </ListItem>
                            <ListItem divider={true}>
                                <ListItemText disableTypography={true}>
                                    <Typography variant="subtitle1">{target}</Typography>
                                </ListItemText>
                            </ListItem>
                        </InnerList>
                    </ListItem>
                );
            })}
        </OuterList>
    );
};
